import {Suspense} from 'react';
import './App.css';
import {Outlet, RouterProvider, useLocation,} from 'react-router-dom';

import {Drawer} from './app/common/components/Drawer/Drawer';
import {useBrowserRouter, useRoutes} from './app/utils/routes';
import {LinearProgress} from '@mui/material';
import {Toolbar} from './app/common/components/Toolbar/Toolbar';

export function NoMatch() {
  const location = useLocation();
  return (
    <h1>
      <code>{location.pathname}</code> not found
    </h1>
  );
}

export function NotImplemented() {
  const location = useLocation();
  return (
    <h1>
      <code>{location.pathname}</code> is not implemented yet
    </h1>
  );
}

export function AppLayout() {
  const routes = useRoutes();
  return (<>
    <Drawer routes={routes} className='drawer'/>
    <Toolbar/>
    <main className='content'>
      <Suspense fallback={<LinearProgress/>}>
        <Outlet/>
      </Suspense>
    </main>
  </>);
}

function App() {
  const router = useBrowserRouter();
  return (
    <RouterProvider router={router}/>
  );
}

export default App;
